import type { FC } from 'react';
import { Skeleton } from '@chakra-ui/react';
import { BloomreachProductType } from '../../hooks/use-search/use-search-types';
import { RecipeTileSkeleton } from './RecipeTileSkeleton';

interface ProductTileSkeletonProps {
    productType?: BloomreachProductType;
}

/**
 * Generic skeleton component for product tiles.
 * Renders the appropriate skeleton based on product type.
 */
export const ProductTileSkeleton: FC<ProductTileSkeletonProps> = ({ productType }) => {
    if (productType === BloomreachProductType.recipe) {
        return <RecipeTileSkeleton />;
    }

    // Default skeleton for hardgood/culinary
    return (
        <Skeleton height={{ base: '392px', sm: '427px', md: '456px', lg: '573px', xl: '612px' }} />
    );
};
